import { Box } from '@mui/material';
import { SocketClientMessage } from '@okletsplay/core';
import { useKeycloak } from '@react-keycloak/web';
import { useSocketSubscriber } from 'app/hooks/socket';
import { NotificationsList } from 'modules/notifications/components/NotificationsList/NotificationsList';
import { TILE_HEIGHT } from 'modules/notifications/constants';
import { notificationsReducers } from 'modules/notifications/store/notifications/slice';
import React, { FC, useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useFetchData } from 'app/hooks/store';
import { getNotificationsList } from 'modules/notifications/store/notifications/repository';

export const NotificationsListContainer: FC = () => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const ref = useRef<HTMLDivElement>();

  const actions = useMemo(() => [getNotificationsList()], []);
  const { loading, fetch } = useFetchData(actions, { fetchOnInit: false });

  useSocketSubscriber([
    {
      action: SocketClientMessage.Notification,
      handler: () => {
        dispatch(notificationsReducers.setReload(true));
        fetch(false);
      },
    },
  ]);

  const nextHandler = useCallback(() => {
    dispatch(notificationsReducers.setReload(false));
    fetch();
  }, [dispatch, fetch]);

  useEffect(() => {
    if (keycloak?.authenticated) {
      const limit = ref.current?.clientHeight
        ? Math.ceil((ref.current?.clientHeight ?? 0) / TILE_HEIGHT) + 1
        : 0;
      if (limit) {
        dispatch(notificationsReducers.setOffset(0));
        dispatch(notificationsReducers.setLimit(limit));
        fetch();
      }
    }
  }, [dispatch, fetch, keycloak?.authenticated]);

  return (
    <>
      <Box ref={ref} height="100%" width="100%">
        <NotificationsList loading={loading} onNext={nextHandler} />
      </Box>
    </>
  );
};
